module.exports = __webpack_public_path__ + "static/media/Smartphone.c3a5d4cd.svg";